import { WithDeletedQueryDto, type WithDeletedQueryInterface } from '@zaoblako/shared/common/dtos/with-deleted-query.dto';
import { TransitTaskFindDto, type TransitTaskFindInterface } from '@zaoblako/shared/modules/cctv/dtos/transit-task/transit-task-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { CctvDtoKeysEnum } from '@zaoblako/shared/modules/cctv/enums/cctv-dto-keys.enum';

/** Transit task find one API query parameters - DTO signature */
export interface TransitTaskFindOneQueryInterface extends WithDeletedQueryInterface {
  /** Fields to select */
  select?: (keyof TransitTaskFindInterface)[];
}

/** Transit task find one API query parameters - DTO schema */
export const TransitTaskFindOneQueryDto = SerdeDtoClass.from<WithDeletedQueryInterface, TransitTaskFindOneQueryInterface>(
  WithDeletedQueryDto,
  CctvDtoKeysEnum.TRANSIT_TASK_FIND_ONE_QUERY_DTO,
  {
    select: {
      optional: true,
      label: 'Выбрать поля',
      serializer: SerdeDtoClass.getSelectablePropertiesValidator(TransitTaskFindDto),
    },
  },
);
